/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import '../vendors/swiper-bundle.min';
import splide from '../vendors/splide.min';
import slick from '../vendors/slick.min';
import '../vendors/lity.min';
import ScrollReveal from '../vendors/scrollreveal';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

jQuery( function() {
	/**
	 * Header Wrapper Height Calculation for Navigation Overlay
	 */

	if ( jQuery( '.header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.header-wrapper' ).each( function() {
				jQuery( this ).css( '--gb_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}

	/**
	 * Toggle menu for mobile
	 */

	const navOverlay = jQuery( '.nav-overlay' );
	const htmlBody = jQuery( 'html, body' );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		navOverlay.toggleClass( 'open' );
		htmlBody.toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */

	jQuery( '.menu-item-has-children > a:first-child' ).each( function() {
		jQuery( this ).after( '<span class="submenu-icon"></span>' );
	} );

	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

	jQuery( '.header-nav' ).on( 'click', '.submenu-icon', function() {
		const parentLi = jQuery( this ).closest( 'li' );

		parentLi.siblings( '.active' )
			.removeClass( 'active' )
			.find( 'ul' ).slideUp();

		parentLi.toggleClass( 'active' ).find( 'ul' ).stop( true, true ).slideToggle();
		parentLi.parents( 'ul' ).toggleClass( 'disabled-menu', parentLi.hasClass( 'active' ) );
	} );

	if ( jQuery( '.more-photos' ).length > 0 ) {
		jQuery( '.more-photos' ).magnificPopup( {
			type: 'inline',
			midClick: true,
			fixedContentPos: true,
			callbacks: {
				open() {
					jQuery( '.slider-single-block' ).slick( {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: true,
						fade: false,
						infinite: true,
						useTransform: true,
						centerMode: true,
						speed: 400,
						cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
					} );

					jQuery( '.slider-nav-block' ).on( 'init', function() {
						jQuery( '.slider-nav-block .slick-slide.slick-current' ).addClass( 'is-active' );
					} ).slick( {
						arrows: false,
						slidesToShow: 7,
						slidesToScroll: 1,
						dots: false,
						focusOnSelect: false,
						infinite: true,
						centerMode: true,
						variableWidth: true,
					} );
				},
			},
		} );

		jQuery( document ).on( 'afterChange', '.slider-single-block', function( event, slick, currentSlide ) {
			jQuery( '.slider-nav-block' ).slick( 'slickGoTo', currentSlide );
			const navElem = '.slider-nav-block .slick-slide[data-slick-index="' + currentSlide + '"]';
			jQuery( '.slider-nav-block .slick-slide.is-active' ).removeClass( 'is-active' );
			jQuery( navElem ).addClass( 'is-active' );
		} );

		jQuery( document ).on( 'click', '.slider-nav-block .slick-slide', function( e ) {
			e.preventDefault();
			const index = jQuery( this ).data( 'slick-index' );
			jQuery( '.slider-single-block' ).slick( 'slickGoTo', index );
		} );
	}

	jQuery( document ).on( 'click', '.popup-modal-dismiss,.close-popup', function( e ) {
		e.preventDefault();
		jQuery.magnificPopup.close();
	} );

	/**
	 *  Accessibility for Simple menu & Mega menu
	 */
	jQuery( '.menu-item-has-children > a' ).on( 'focus blur', function( event ) {
		jQuery( this ).siblings( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	jQuery( '.sub-menu a, .mega-menu a' ).on( 'focus blur', function( event ) {
		jQuery( this ).closest( '.sub-menu, .mega-menu' ).toggleClass( 'focused', event.type === 'focus' );
	} );

	/**
	 * Script for Accessibility of html Tags
	 */

	jQuery( 'h1, h2, h3, h4, h5, h6,p,li,blockquote,cite,strong,dt,dd,th,td,b,i,u,s,em,small,sup,del,ins,abbr,mark,details,pre,kbd,samp,var,address,code,q,figure,figcaption,caption,.top-bar-text,.top-bar-cross,.copy-right,.post-author-img,.post-author-name,.post-meta-date,.post-date' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	jQuery( '.header-nav li, .blog-nav li, .footer-nav li, .legal-nav li' ).each( function() {
		const link = jQuery( this ).find( 'a' );
		if ( link.length > 0 ) {
			jQuery( this ).removeAttr( 'tabindex' );
		} else {
			jQuery( this ).attr( 'tabindex', '0' );
		}
	} );

	jQuery( 'form p' ).each( function() {
		jQuery( this ).removeAttr( 'tabindex' );
	} );

	jQuery( 'a,button:not([href])' ).each( function() {
		jQuery( this ).attr( {
			tabindex: 0,
		} );
	} );

	setTimeout( () => {
		jQuery( '#daextlwcnf-cookie-notice-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-notice-button-2' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-1' ).attr( 'role', 'button' );
		jQuery( '#daextlwcnf-cookie-settings-button-2' ).attr( 'role', 'button' );
	}, 500 );

	autosize();

	function autosize() {
		const text = jQuery( 'textarea' );

		text.each( function() {
			jQuery( this ).attr( 'rows', 5 );
			resize( jQuery( this ) );
		} );

		text.on( 'input', function() {
			resize( jQuery( this ) );
		} );

		function resize( $text ) {
			$text.css( 'min-height', 'auto' );
			$text.css( 'min-height', $text[ 0 ].scrollHeight + 'px' );
		}
	}

	// // Header Search
	if ( jQuery( '.hero-swiper' ).length > 0 ) {
		new Swiper( '.hero-swiper', {
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		} );
	}

	if ( jQuery( '.js-stays-images-detail-slider' ).length > 0 && jQuery( window ).width() < 1004 ) {
		jQuery( '.js-stays-images-detail-slider' ).each( function() {
			const slider = jQuery( this );
			new Swiper( slider[ 0 ], {
				slidesPerView: 'auto',
				spaceBetween: 10,
				slidesPerGroup: 1,
				loop: false,
				centeredSlides: true,
				pagination: {
					el: slider.find( '.swiper-pagination' )[ 0 ],
					type: 'progressbar',
				},

				navigation: {
					nextEl: slider.find( '.gallery-swiper-button-next' )[ 0 ],
					prevEl: slider.find( '.gallery-swiper-button-prev' )[ 0 ],
				},

				breakpoints: {
					0: {
						slidesPerView: 'auto',
						spaceBetween: 10,
						centeredSlides: true,
						loop: true,
					},
					768: {
						slidesPerView: 2,
					},
					1004: {
						slidesPerView: 3,
					},
				},
			} );
		} );
	}

	if ( jQuery( '.js-scrolling-slider' ).length ) {
		jQuery( '.js-scrolling-slider' ).each( function() {
			const $slider = jQuery( this );
			const $slides = $slider.children();

			for ( let i = 0; i < 9; i++ ) {
				$slider.append( $slides.clone() );
			}

			$slider.slick( {
				arrows: false,
				dots: false,
				variableWidth: true,
				infinite: true,
				autoplay: true,
				speed: 5000,
				autoplaySpeed: 0,
				cssEase: 'linear',
				touchThreshold: 200,
				pauseOnHover: false,
				draggable: false,
			} );
		} );
	}

	if ( jQuery( '.js-images-slider' ).length ) {
		jQuery( '.js-images-slider' ).each( function() {
			const $slider = jQuery( this );
			$slider.slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				speed: 500,
				touchThreshold: 200,
				autoplay: true,
				fade: true,
			} );
		} );
	}

	if ( jQuery( '.services-slider' ).length ) {
		jQuery( '.services-slider' ).each( function() {
			const $slider = jQuery( this );
			const $parent = $slider.closest( '.services-slider-main' );
			$slider.slick( {
				centerMode: true,
				slidesToShow: 4,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				prevArrow: $parent.find( '.services-swiper-button-prev' ),
				nextArrow: $parent.find( '.services-swiper-button-next' ),
				dots: false,
				speed: 1000,
				cssEase: 'linear',
				touchThreshold: 200,
				responsive: [
					{ breakpoint: 1180, settings: {	speed: 800 } },
					{ breakpoint: 1024, settings: { speed: 800 } },
					{ breakpoint: 768, settings: { speed: 500, slidesToShow: 3 } },
					{ breakpoint: 480, settings: { speed: 500, slidesToShow: 3 } },
				],
			} );

			const $progressWrap = $parent.find( '.swiper-pagination' );
			$progressWrap.html( '<div class="progress-bar"><span></span></div>' );

			function setProgressBar( currentSlide, slideCount ) {
				const calc = ( ( currentSlide + 1 ) / slideCount ) * 100;
				$progressWrap.find( 'span' ).css( 'width', calc + '%' );
			}

			$slider.on( 'init reInit afterChange', function( event, slick, currentSlide ) {
				const i = ( currentSlide ? currentSlide : 0 );
				setProgressBar( i, slick.slideCount );
			} );

			// Sirf slider container ko reveal karna
			ScrollReveal().reveal( $slider.get( 0 ), {
				duration: 600,
				opacity: 0,
				distance: '30px',
				easing: 'ease-in-out',
				afterReveal() {
				// Jab slider viewport me aaye to stagger animation run karein
					$slider.find( '.service-single-slide' ).each( function( i, el ) {
						setTimeout( () => {
							jQuery( el ).addClass( 'slide-in' );
						}, i * 150 ); // stagger delay
					} );
				},
			} );
		} );
	}

	if ( jQuery( '.location-slider' ).length ) {
		jQuery( '.location-slider' ).each( function() {
			const $slider = jQuery( this );
			const $parent = jQuery( this ).closest( '.location-slider-main' );
			$slider.slick( {
				infinite: true,
				centerMode: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				prevArrow: $parent.find( '.location-swiper-button-prev' ),
				nextArrow: $parent.find( '.location-swiper-button-next' ),
				dots: false,
				speed: 500,
				touchThreshold: 200,
				responsive: [
					{ breakpoint: 1180, settings: { slidesToShow: 3 } },
					{ breakpoint: 1024, settings: { slidesToShow: 2 } },
					{ breakpoint: 768, settings: { slidesToShow: 1 } },
					{ breakpoint: 480, settings: { slidesToShow: 1 } },
				],
			} );

			const $progressWrap = $parent.find( '.swiper-pagination' );
			$progressWrap.html( '<div class="progress-bar"><span></span></div>' );

			function setProgressBar( currentSlide, slideCount ) {
				const calc = ( ( currentSlide + 1 ) / slideCount ) * 100;
				$progressWrap.find( 'span' ).css( 'width', calc + '%' );
			}

			$slider.on( 'init reInit afterChange', function( event, slick, currentSlide ) {
				const i = ( currentSlide ? currentSlide : 0 );
				setProgressBar( i, slick.slideCount );
			} );
		} );
	}

	if ( jQuery( '.js-love-letter-slider' ).length ) {
		jQuery( '.js-love-letter-slider' ).each( function() {
			const $slider = jQuery( this );
			const $parent = jQuery( this ).closest( '.love-letter-main' );
			$slider.slick( {
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				prevArrow: $parent.find( '.location-swiper-button-prev' ),
				nextArrow: $parent.find( '.location-swiper-button-next' ),
				dots: false,
				speed: 500,
				touchThreshold: 200,
				responsive: [
					{ breakpoint: 1180, settings: { slidesToShow: 3 } },
					{ breakpoint: 1024, settings: { slidesToShow: 2 } },
					{ breakpoint: 768, settings: { slidesToShow: 1 } },
					{ breakpoint: 480, settings: { slidesToShow: 1 } },
				],
			} );
		} );
	}

	if ( jQuery( '.js-scrollable-slider' ).length > 0 ) {
		jQuery( '.js-scrollable-slider' ).each( function() {
			const $slider = jQuery( this );
			$slider.slick( {
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				dots: false,
				autoplay: true,
				speed: 500,
				touchThreshold: 200,
			} );
		} );
	}

	if ( jQuery( window ).width() < 1004 ) {
		if ( jQuery( '.video-tiles-area' ).length ) {
			jQuery( '.video-tiles-area' ).each( function() {
				const $slider = jQuery( this );
				$slider.slick( {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					touchThreshold: 20,
				} );
			} );
		}
	}

	if ( jQuery( '.featured-stay-slider' ).length > 0 ) {
		jQuery( '.featured-stay-slider' ).each( function() {
			const slider = jQuery( this );
			new Swiper( slider[ 0 ], {
				slidesPerView: 1,
				spaceBetween: 0,
				slidesPerGroup: 1,
				loop: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: slider.find( '.swiper-pagination' )[ 0 ],
					type: 'progressbar',
				},
				navigation: {
					nextEl: slider.find( '.swiper-button-next' )[ 0 ],
					prevEl: slider.find( '.swiper-button-prev' )[ 0 ],
				},
			} );
		} );
	}

	if ( jQuery( '.perk-slider' ).length ) {
		jQuery( '.perk-slider' ).each( function() {
			const $slider = jQuery( this );
			const $parent = jQuery( this ).closest( '.perk-slider-main' );
			$slider.slick( {
				infinite: true,
				centerMode: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				variableWidth: false,
				arrows: true,
				prevArrow: $parent.find( '.services-swiper-button-prev' ),
				nextArrow: $parent.find( '.services-swiper-button-next' ),
				dots: false,
				speed: 500,
				touchThreshold: 200,
				responsive: [
					{ breakpoint: 1180, settings: { slidesToShow: 3 } },
					{ breakpoint: 1024, settings: { slidesToShow: 2 } },
					{ breakpoint: 768, settings: { slidesToShow: 1 } },
					{ breakpoint: 480, settings: { slidesToShow: 1 } },
				],
			} );

			const $progressWrap = $parent.find( '.swiper-pagination' );
			$progressWrap.html( '<div class="progress-bar"><span></span></div>' );

			function setProgressBar( currentSlide, slideCount ) {
				const calc = ( ( currentSlide + 1 ) / slideCount ) * 100;
				$progressWrap.find( 'span' ).css( 'width', calc + '%' );
			}

			$slider.on( 'init reInit afterChange', function( event, slick, currentSlide ) {
				const i = ( currentSlide ? currentSlide : 0 );
				setProgressBar( i, slick.slideCount );
			} );
		} );
	}

	if ( jQuery( '.filter-single' ).length ) {
		jQuery( '.child-terms' ).hide();
		jQuery( '.filter-group.parent-term' ).on( 'click', function() {
			jQuery( this ).toggleClass( 'active' ).next( '.child-terms' ).slideToggle();
		} );
	}

	if ( jQuery( '#social-posts-slider' ).length ) {
		const marqueeSlider = new Splide( '#social-posts-slider', {
			type: 'loop',
			arrows: false,
			pagination: false,
			perMove: 1,
			perPage: 5,
			gap: '30px',
			drag: true,
			autoScroll: {
				speed: 0.8,
			},

			breakpoints: {
				0: {
					autoplay: false,
				},
				768: {
					gap: '10px',
					autoplay: true,
					perPage: 1,
					autoScroll: {
						speed: 0.5,
					},
				},
			},
		} );

		marqueeSlider.mount( { AutoScroll: window.splide.Extensions.AutoScroll } );
	}

	// Faqs

	if ( jQuery( '.faq-head' ).length > 0 ) {
		jQuery( '.faq-head' ).on( 'click keypress', function() {
			const currentFaq = jQuery( this );

			if ( currentFaq.hasClass( 'active' ) ) {
				currentFaq.removeClass( 'active' );
				currentFaq.parent().removeClass( 'active' );
				currentFaq.siblings( '.faq-content' ).slideUp( 300 );
			} else {
				jQuery( '.faq-head' ).removeClass( 'active' );
				jQuery( '.faq' ).removeClass( 'active' );
				jQuery( '.faq-content' ).slideUp();

				currentFaq.addClass( 'active' );
				currentFaq.parent().addClass( 'active' );
				currentFaq.siblings( '.faq-content' ).slideDown( 300 );
			}
		} );
	}
	// Header Search

	jQuery( '#js-search-icon-btn' ).on( 'click', function() {
		jQuery( '.header-search-area' ).addClass( 'show-search-bar' );
		jQuery( '.header-search-inner input[type="search"]' ).focus();
	} );

	jQuery( '.js-close-search-button' ).on( 'click', function() {
		jQuery( '.header-search-area' ).removeClass( 'show-search-bar' );
		jQuery( '.header-search-inner' ).find( 'input[type="search"]' ).val( '' );
	} );

	if ( jQuery( '.range-slider' ).length > 0 ) {
		function getVals() {
			const parent = jQuery( this ).parent();
			const slides = parent.find( 'input' );
			let slide1 = parseFloat( slides.eq( 0 ).val() );
			let slide2 = parseFloat( slides.eq( 1 ).val() );
			if ( slide1 > slide2 ) {
				const tmp = slide2; slide2 = slide1; slide1 = tmp;
			}
			const displayElement = parent.find( '.rangeValues' ).eq( 0 );
			// displayElement.html( '' + slide1 + ' - ' + slide2 );
		}

		jQuery( window ).on( 'load', function() {
			const sliderSections = jQuery( '.range-slider' );
			sliderSections.each( function() {
				const sliders = jQuery( this ).find( 'input' );
				sliders.each( function() {
					if ( jQuery( this ).attr( 'type' ) === 'range' ) {
						jQuery( this ).on( 'input', getVals );
						jQuery( this ).trigger( 'input' );
					}
				} );
			} );
		} );
	}

	if ( jQuery( '.show-more-filter-item-title' ).length > 0 ) {
		jQuery( '.show-more-filter-item-title' ).each( function() {
			jQuery( this ).on( 'click', function() {
				const content = jQuery( this ).prev( '.show-more-filter-item-content' );
				const isOpen = jQuery( this ).hasClass( 'dropdown-expanded' );

				jQuery( '.show-more-filter-item-content' ).slideUp();
				jQuery( '.show-more-filter-item-title' )
					.removeClass( 'dropdown-expanded' )
					.text( 'Show More' );

				if ( ! isOpen ) {
					content.slideDown();
					jQuery( this )
						.addClass( 'dropdown-expanded' )
						.text( 'Show Less' );
				}
			} );
		} );
	}

	if ( jQuery( '.select-dropdown' ).length ) {
		jQuery( '.select-dropdown__button' ).on( 'click', function( event ) {
			event.stopPropagation();
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			jQuery( '.filter-dropdown-button' ).removeClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__button' ).toggleClass( 'is-button-opened' );
			dropdown.find( '.select-dropdown__list' ).toggleClass( 'is-active-dropdown' );
			jQuery( '.filter-checkboxes' ).removeClass( 'is-active-dropdown' );
			// jQuery( this ).closest( '.menu-drop-down .select-dropdown__list' ).slideToggle();
		} );

		jQuery( '.filter-button,.popular-filter-item' ).on( 'click', function( event ) {
			event.stopPropagation();
			const dropdown = jQuery( this ).closest( '.select-dropdown' );
			const button = dropdown.find( '.select-dropdown__button' );
			dropdown.find( '.filter-button' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			const itemValue = jQuery( this ).text();
			button.text( itemValue );
			jQuery( '.filter-checkboxes,.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
			dropdown.find( '.select-dropdown__button' ).removeClass( 'is-button-opened' );
		} );

		jQuery( document ).on( 'click', function() {
			jQuery( '.select-dropdown__button' ).removeClass( 'is-button-opened' );
			jQuery( '.filter-checkboxes,.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
		} );
	}

	if ( jQuery( '.stays-filter-area' ).length ) {
		jQuery( '.js-mobile-filter-button' ).on( 'click', function( event ) {
			event.stopPropagation();
			const dropdown = jQuery( this ).closest( '.stays-filter-area,.stays-price-range' );
			jQuery( '.filter-dropdown-button' ).removeClass( 'is-button-opened' );
			dropdown.find( '.js-mobile-filter-button' ).toggleClass( 'is-button-opened' );
			jQuery( '.filter-checkboxes,.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
			dropdown.find( '.filter-checkboxes' ).addClass( 'is-active-dropdown' );
			// jQuery( this ).closest( '.menu-drop-down .filter-checkboxes' ).slideToggle();
		} );

		jQuery( '.popular-filter-item' ).on( 'click', function( event ) {
			event.stopPropagation();
			const dropdown = jQuery( this ).closest( '.stays-filter-area,.stays-price-range' );
			const button = dropdown.find( '.js-mobile-filter-button' );
			dropdown.find( '.filter-button' ).removeClass( 'active' );
			jQuery( this ).addClass( 'active' );
			const itemValue = jQuery( this ).siblings( 'label' ).text();
			button.text( itemValue );
			jQuery( '.filter-checkboxes,.select-dropdown__list' ).removeClass( 'is-active-dropdown' );
			dropdown.find( '.js-mobile-filter-button' ).removeClass( 'is-button-opened' );
		} );

		jQuery( document ).on( 'click', function() {
			jQuery( '.js-mobile-filter-button' ).removeClass( 'is-button-opened' );
			jQuery( '.filter-checkboxes' ).removeClass( 'is-active-dropdown' );
		} );
	}

	if ( jQuery( '.popup-button' ).length > 0 ) {
		jQuery( '.popup-button' ).magnificPopup( {
			type: 'inline',
			midClick: true,
			fixedContentPos: true,
		} );
		jQuery( document ).on( 'click', '.popup-modal-dismiss', function( e ) {
			e.preventDefault();
			$.magnificPopup.close();
		} );
	}

	if ( jQuery( '#histogram' ).length > 0 ) {
		const minRange = jQuery( '#minRange' );
		const maxRange = jQuery( '#maxRange' );
		const minVal = jQuery( '#minimum-value' );
		const maxVal = jQuery( '#maximum-value' );

		const MIN_RANGE = 0;
		const MAX_RANGE = 100;
		function updateValues() {
			const min = Math.min( +minRange.val(), +maxRange.val() );
			const max = Math.max( +minRange.val(), +maxRange.val() );
			minRange.val( min );
			maxRange.val( max );
			minVal.text( `$${ min }` );
			if ( max === 800 ) {
				maxVal.text( `$${ max }+` );
			} else {
				maxVal.text( `$${ max }` );
			}
		}

		minRange.on( 'input', updateValues );
		maxRange.on( 'input', updateValues );
		updateValues();
	}

	if ( jQuery( '.post-video-area' ).length > 0 ) {
		const video = jQuery( '.theme-image-main' ).find( '.wp-block-video video' )[ 0 ];
		const videoArea = jQuery( '.theme-image-main' ).find( '.post-video-area' );
		const muteIconButton = jQuery( '.theme-image-main' ).find( '.play-icon button.audio-icon' );
		const playIconButton = jQuery( '.theme-image-main' ).find( '.play-icon button.play-icon-btn' );

		muteIconButton.on( 'click', function() {
			if ( video.muted ) {
				video.muted = false;
				muteIconButton.addClass( 'unmute-video' );
			} else {
				video.muted = true;
				muteIconButton.removeClass( 'unmute-video' );
			}
		} );

		playIconButton.on( 'click', function() {
			jQuery( videoArea ).fadeIn();
			if ( video.paused ) {
				video.play();
				playIconButton.removeClass( 'pause-video' );
			} else {
				video.pause();
				playIconButton.addClass( 'pause-video' );
			}
		} );
	}

	// Animation
	const baseConfig = {
		duration: 1200,
		distance: '0px',
		origin: 'bottom',
		opacity: 0,
		easing: 'ease-in-out',
		reset: false,
		viewOffset: { top: window.innerHeight * 0.2, right: 0, bottom: 0, left: 0 },
	};

	ScrollReveal().reveal( '.page-section section, footer', baseConfig );

	ScrollReveal().reveal( 'footer-cta-inner, .hero-default-content, .hero-swiper .swiper-pagination, .featured-stay-single, .location-slider-main, .perk-slider-main, .featured-post-ctn', {
		...baseConfig,
		duration: 1100,
		delay: 100,
	} );

	ScrollReveal().reveal( '.wp-block-columns .wp-block-column, .sb-post-item-wrap', {
		...baseConfig,
		duration: 1000,
		delay: 150,
	} );

	ScrollReveal().reveal( '.stays-list-item, .post-teaser-inner.three-columns .post-single, .text-image-column', {
		...baseConfig,
		duration: 1000,
		delay: 200,
	} );
} );

